import { Link } from "react-router-dom";

const categories = [
  {
    name: "Lounge Chairs",
    description: "Teak, wicker & aluminum chairs for ultimate relaxation",
    image: "https://public.readdy.ai/ai/img_res/4ca7cf4d45a71c682d0598bc4f3a983e.jpg",
    count: 9,
  },
  {
    name: "Dining Sets",
    description: "Complete outdoor dining solutions for every occasion",
    image: "https://readdy.ai/api/search-image?query=outdoor%20dining%20table%20set%20with%20chairs%20on%20beautiful%20patio%2C%20teak%20wood%20table%2C%20wicker%20chairs%2C%20garden%20setting%2C%20warm%20evening%20light%2C%20elegant%20outdoor%20dining%20lifestyle%20photography&width=500&height=650&seq=cat002&orientation=portrait",
    count: 6,
  },
  {
    name: "Sofas & Sets",
    description: "Wicker sectionals and conversation sets for outdoor living",
    image: "https://readdy.ai/api/search-image?query=luxury%20outdoor%20wicker%20sofa%20sectional%20set%20on%20modern%20patio%2C%20thick%20cushions%2C%20beautiful%20garden%20background%2C%20warm%20sunlight%2C%20premium%20outdoor%20living%20lifestyle%20photography&width=500&height=650&seq=cat003&orientation=portrait",
    count: 7,
  },
];

export default function CategorySection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-[#4A7C2F] text-sm font-medium tracking-widest uppercase">Browse By Style</span>
          <h2 className="text-4xl font-bold text-[#1a1a1a] mt-2" style={{ fontFamily: "'Playfair Display', serif" }}>
            Shop By Category
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {categories.map((cat, i) => (
            <Link
              key={cat.name}
              to="/products"
              className={`group relative overflow-hidden rounded-2xl cursor-pointer ${i === 0 ? "md:row-span-1" : ""}`}
            >
              <div className="w-full h-[420px]">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <span className="text-white/60 text-xs tracking-widest uppercase mb-2 block">{cat.count} Products</span>
                <h3 className="text-white text-2xl font-bold mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {cat.name}
                </h3>
                <p className="text-white/70 text-sm leading-relaxed mb-4">{cat.description}</p>
                <span className="inline-flex items-center gap-2 text-white text-sm font-medium border-b border-white/40 pb-0.5 group-hover:border-white transition-colors">
                  Explore <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
